module.exports = __webpack_public_path__ + "img/iconmonstr-plus-2.ba232aa7.svg";